import { z } from "zod/v4";
import { documentSchema, folderSchema } from "../schemas/document";
import { fetchApi, fetchUpload, fetchVoid } from "./internal";

export const folders = {
	list: (clubId: string, parentId?: string) => {
		const params = parentId ? `?parent_id=${parentId}` : "";
		return fetchApi(`/clubs/${clubId}/folders${params}`, z.array(folderSchema));
	},
	create: (clubId: string, data: unknown) =>
		fetchApi(`/clubs/${clubId}/folders`, folderSchema, {
			method: "POST",
			body: JSON.stringify(data),
		}),
	delete: (clubId: string, folderId: string) =>
		fetchVoid(`/clubs/${clubId}/folders/${folderId}`, { method: "DELETE" }),
};

export const documents = {
	list: (clubId: string, folderId?: string) => {
		const params = folderId ? `?folder_id=${folderId}` : "";
		return fetchApi(`/clubs/${clubId}/documents${params}`, z.array(documentSchema));
	},
	upload: (clubId: string, file: File, folderId?: string) => {
		const formData = new FormData();
		formData.append("file", file);
		if (folderId) formData.append("folder_id", folderId);
		return fetchUpload(`/clubs/${clubId}/documents`, documentSchema, formData);
	},
	delete: (clubId: string, docId: string) =>
		fetchVoid(`/clubs/${clubId}/documents/${docId}`, { method: "DELETE" }),
};
